import { getToken } from "js/formatting/getToken";
import config from "config/config";
export async function setUpPolicyAutoPayApi(payload) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(payload),
  };
  const response = await fetch(
    `${config.REG_API_BASE_URL}/Payment/autopay`,
    options
  );
  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    return data;
  }
}
